import { render, staticRenderFns } from "./guideDetail.vue?vue&type=template&id=361fec66&scoped=true"
import script from "./guideDetail.vue?vue&type=script&lang=js"
export * from "./guideDetail.vue?vue&type=script&lang=js"
import style0 from "./guideDetail.vue?vue&type=style&index=0&id=361fec66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361fec66",
  null
  
)

export default component.exports